export default __webpack_public_path__ + "static/media/icon.bf863247.svg";